"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadRoleDetails = void 0;
const create_ac_1 = require("@app/ac/util/create-ac");
const request_role_details_1 = require("../request/request-role-details");
const util_1 = require("@app/util");
const user_details_1 = require("@app/reducer/user-details");
exports.loadRoleDetails = (0, create_ac_1.createAC)(async (dispatch, args) => {
    const data = await (0, request_role_details_1.requestRoleDetails)(args);
    if ((0, util_1.isUndefined)(data))
        return;
    dispatch((0, user_details_1.setRole)(data));
    return data;
});
